<template>
  <div>
    <NavTop class="navbar">
      <template v-slot:mainnavlist>
        <!-- <div @click="routerpush('/')" class="nav">首页</div> -->
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            学校概括<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>
              <div @click="routerpush('/profiles')">学校简介</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="routerpush('/leader')">现任领导</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="routerpush('/nav')">校园导航</div>
            </el-dropdown-item>
            <el-dropdown-item>VR全景校园</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="routerpush('/institution')">机构设置</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            党建原地<i class=" "></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>
              <div @click="routerpush('/partyActive')">党建活动</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="routerpush('/theory')">相关制度</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="openExternalLink">
          <a style="color: #fff;text-decoration: none;" href="https://www.ttcdw.cn/h/spec/hbdongfang/"
             @click.stop>教师研修</a>
        </div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            招生就业<i class=" "></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>
              <div @click="routerpush('/enrollment')">招生信息</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <a class="jiuyXX" style="color: #606266; text-decoration: none;" href="https://hbdfxyjob.jysd.com/"
                 target="_target">就业信息</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="routerpush('/talents')">人才培养</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            走进东方<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>
              <el-dropdown-item><div @click="routerpush('/life')" >校园生活</div></el-dropdown-item>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="routerpush('/schoolStyle')">校园风采</div>
            </el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="routerpush('/student')">学生服务</div>

      </template>
    </Navtop>

    <!-- 轮播图 -->
    <div class="block">
      <el-carousel ref="carousel" trigger="click" height="380px" indicator-position="none" arrow="never"
                   :activeIndex="currentIndexBanner" @change="handleCarouselChange" class="banner_carousel">
        <el-carousel-item v-for="(item, index) in bannerImg" :key="index">
          <img :src="item" alt="Carousel Image" class="banner_img">
        </el-carousel-item>
      </el-carousel>
      <div class="banner_dots">
        <span v-for="(image, index) in bannerImg" :key="index" :class="{ 'bannerActive': index === currentIndexBanner }"
              @click="goToBannerSlide(index)"></span>
      </div>
    </div>
    <div class="center" ref="targetDiv">
      <div class="left_box">
        <!-- 左侧导航框 -->
        <aside class="sidebar">
          <div class="left_title">
            <div>
              学校概况
            </div>
            <div>
              ABOUT CUEB
            </div>
          </div>
          <ul class="left_nav">
            <li v-for="(item, index) in navItems" :key="index" @click="navigateTo(item.path)">
              {{ item.name }}
            </li>
          </ul>
        </aside>
      </div>
      <div class="right_box">
        <div class="row between border_bottom">
          <div class="title">
            <h3>VR全景校园</h3>
          </div>
          <div class="right_link">
            <router-link class="link" to="/">首页</router-link>
            /
            <router-link to="/vr"
                         class="link">学校概况
            </router-link>
            /
            <router-link to="/profiles" class="link">VR全景校园</router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import NavTop from '../../components/comcomponents/NavTop.vue'

export default {
  components: {NavTop},
  data () {
    return {
      interval: null,
      currentIndex: 0, //新闻轮播图
      currentIndexBanner: 0, // banner轮播图

      // 首页头部轮播图
      bannerImg: [
        require('../../assets/images/banner1.png'), // 替换为你的图片路径
        require('../../assets/images/banner2.png'),
        require('../../assets/images/banner3.png'),
        require('../../assets/images/banner2.png'),
      ],
      navItems: [
        {name: '首页', path: '/home'},
        {name: '学校简介', path: '/profiles'},
        {name: '现任领导', path: '/leader'},
        {name: '校园导航', path: '/nav'},
        {name: 'VR校园全景', path: '/'},

      ],
    }
  },
  mounted () {
    this.scrollToDiv()
  },
  methods: {
    openExternalLink (event) {
      // 阻止默认事件，防止a标签打开新页面
      event.preventDefault()
      // 使用window.location.href进行跳转
      window.location.href = event.target.href
    },
    handleCarouselChange (index) {
      this.currentIndexBanner = index
    },
    goToBannerSlide (index) {
      this.currentIndexBanner = index
      this.$nextTick(() => {
        this.$refs.carousel.setActiveItem(index)
      })
    },
    routerpush (to) {
      this.$router.push(to)
      // 跳转之后，记得关闭菜单（在屏幕宽度小于800的时候才生效）
      var dom = document.getElementById('navID')
      if (dom.classList.contains('navlistshow')) {
        dom.classList.remove('navlistshow')
      }
    },
    navigateTo (path) {
      this.$router.push(path)
    },
    scrollToDiv () {
      // 使用 $refs 访问目标 div 元素
      const targetElement = this.$refs.targetDiv
      if (targetElement) {
        // 使用 window.scrollTo() 方法平滑滚动到 div
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth'
        })
      }
    }
  }

}
</script>

<style lang="less" scoped>
.block {
  margin-bottom: 30px;

}

.banner_carousel {
  height: 120% !important;
  position: relative;
  overflow: hidden !important;
}

.banner_img {
  width: 100%;
  height: 100%;
}

.banner_dots {
  position: absolute;
  // bottom: 1%;
  transform: translateY(-160%);
  right: 48%;
  z-index: 10000;
  display: flex;
}

.banner_dots span {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: rgba(85, 85, 85, 0.5);
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
}

.banner_dots span.bannerActive {
  background-color: #8d080e;
  width: 20px;
  border-radius: 40%;
}


.bannerActive {
  color: #fff;
  border-bottom: 1px solid transparent;
  /* 使下边界看起来没有边框 */
}

.el-dropdown-link {
  color: #FFFFFF;
}

.link {
  text-decoration: none;
  color: #333;
}

.nav:hover {
  background-color: #9e070e;
  color: #fff;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
  height: 450px;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.center {
  margin: 0 auto;
  width: 1240px;
  display: flex;
  flex-direction: row;
}

.right_box {
  width: 100%;
}

.sidebar {
  transform: translateY(-70px);
  text-align: center;
  width: 200px;
  height: 100vh;
  margin-right: 50px;
  position: relative;
  z-index: 2000001;
}

.sidebar h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.sidebar .left_nav {
  transform: translateY(-40%);
  list-style: none;
  padding-bottom: 100px;
  background: linear-gradient(170deg, #fafafa 90%, #fff 10%);

}

.sidebar .left_nav li {
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 16px;
  padding: 10px;
  transition: background-color 0.3s;
}

.sidebar .left_nav li {
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 16px;
  padding: 10px;
  transition: background-color 0.3s;
}

.sidebar .left_nav li:hover {
  color: #6a6a6a;
  background-color: #eee;
}


.content-section h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.content-section p {
  font-size: 16px;
  line-height: 1.6;
  color: #555;
}

.title {
  width: 150px;
  height: 50px;
  padding-top: 10px;
  border-bottom: 3px solid #9e070e;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.border_bottom {
  border-bottom: 1px solid #cdcbcc;
}

.left_box {
  display: flex;
}

.left_title {
  background: linear-gradient(-170deg, #9e070e 50%, #fafafa 10%);
  height: 350px;
  padding: 40px 0 0 0;
  color: #FFFFFF;

  div:first-child {
    font-size: 30px;
    margin: 10px;
  }

  div:last-child {
    font-size: 15px;
  }
}

.right_link {
  color: #666;
  font-size: 14px;
}

.txt {
  padding: 40px 0;
  text-indent: 2em;
  line-height: 2em;

}

.nav:hover {
  background-color: #9e070e;
  color: #fff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.dropdown_menu {
  transform: translate(0, -6%);
  width: 120px;

  .el-dropdown-menu__item {
    text-align: center;
  }

  .el-dropdown-menu__item:hover {
    background-color: #8d080e;
    color: #fff;
  }
}

.dropdown {
}

.dropdown:hover {
  background-color: #9e070e;
}
</style>



// WEBPACK FOOTER //
// src/views/vr/vr.vue